<template>
  <div class="auth-wrapper auth-v2 fullscreen">
    <b-row class="auth-inner m-0">

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <img :src="$i18n.locale === 'en' ? '//soustitreur.com/images/logo/logo-closedCaptioner.svg' : '//soustitreur.com/images/logo/logo.png'" style="height:220px;">
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Reset password-->
      <b-col
        lg="4"
        class="d-flex auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <!-- Locale -->
          <div
            class="horizontal-layout"
            style="height:inherit"
          >
            <div class="navbar-container d-flex content align-items-center">
              <b-navbar-nav class="nav align-items-center ml-auto">
                <locale />
              </b-navbar-nav>
            </div>
          </div>
          <!-- /Locale -->
          
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
            
          >
            {{ $t('Reset password')}}
          </b-card-title>
          <code v-if="!isCheckingToken && !isValidToken">{{ $t('Password reset link is invalid or expired.') }}</code>
          <!-- form -->
          <validation-observer ref="simpleRules" v-if="!isCheckingToken && isValidToken">
            <b-form
              class="auth-reset-password-form mt-2"
              method="POST"
              @submit.prevent="savePassword"
            >

              <!-- password -->
              <b-form-group
                :label="$t('New Password')"
                label-for="reset-password-new"
              >
                <validation-provider
                  #default="{ errors, failedRules }"
                  name="Password"
                  vid="Password"
                  rules="required|min:8"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="reset-password-new"
                      v-model="password"
                      :type="password1FieldType"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      name="reset-password-new"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="password1ToggleIcon"
                        @click="togglePassword1Visibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger" v-if="errors.length">{{ $t(`validation.${Object.keys(failedRules)[0]}`, {'_field_':$t('New Password'), 'length':'8'}) }}</small>
                </validation-provider>
              </b-form-group>

              <!-- confirm password -->
              <b-form-group
                label-for="reset-password-confirm"
                :label="$t('Retype New Password')"
              >
                <validation-provider
                  #default="{ errors, failedRules }"
                  name="Confirm Password"
                  rules="required|confirmed:Password"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="reset-password-confirm"
                      v-model="cPassword"
                      :type="password2FieldType"
                      class="form-control-merge"
                      :state="errors.length > 0 ? false:null"
                      name="reset-password-confirm"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="password2ToggleIcon"
                        @click="togglePassword2Visibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger" v-if="errors.length">{{ $t(`validation.${Object.keys(failedRules)[0]}`, {'_field_':$t('Retype New Password')}) }}</small>
                </validation-provider>
              </b-form-group>

              <!-- submit button -->
              <b-button
                block
                type="submit"
                variant="primary"
              >
                {{ $t('Set New Password') }}
              </b-button>
            </b-form>
          </validation-observer>

          <p class="text-center mt-2">
            <b-link :to="{name:'Login'}">
              <feather-icon icon="ChevronLeftIcon" />{{ $t('Back to login') }}
            </b-link>
          </p>
        </b-col>
      </b-col>
      <!-- /Reset password-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow, BCol, BCardTitle, BCardText, BForm, BFormGroup, BInputGroup, BInputGroupAppend, BLink, BFormInput, BButton, BImg, BNavbarNav,
} from 'bootstrap-vue'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Locale from '@/components/header/Locale.vue'
import Apicall from '@/libs/api-call' 


export default {
  components: {
    VuexyLogo,
    BRow,
    BCol,
    BButton,
    BCardTitle,
    BCardText,
    BForm,
    BFormGroup,
    BImg,
    BInputGroup,
    BLink,
    BFormInput,
    BNavbarNav,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
    Locale,
  },
  data() {
    return {
      cPassword: '',
      password: '',
      // validation
      required,

      // Toggle Password
      password1FieldType: 'password',
      password2FieldType: 'password',
      isCheckingToken: false,
      isValidToken: false,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    password1ToggleIcon() {
      return this.password1FieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    password2ToggleIcon() {
      return this.password2FieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  mounted() {
    this.checkToken();
    this.getLanguages();
  },
  methods: {
    togglePassword1Visibility() {
      this.password1FieldType = this.password1FieldType === 'password' ? 'text' : 'password'
    },
    togglePassword2Visibility() {
      this.password2FieldType = this.password2FieldType === 'password' ? 'text' : 'password'
    },
    checkToken() {
      const api = new Apicall();
      this.isCheckingToken = true;
      api.checkToken(this.$route.params.token).then((response) => {
        this.isCheckingToken = false;
        if (response.status === 'OK') {
          this.isValidToken = response.data.data.exists;
        }
      });
    },
    getLanguages() {
      this.$i18n.locale = this.$route.query.language;
    },
    savePassword() {
      const api = new Apicall();
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          api.saveNewPassword(this.$route.params.token, this.cPassword, this.$i18n.locale).then(response => {
            if (response.status === 'OK') { 
              this.$router.push({name:'Login'});
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  variant: 'success',
                  title: this.$t('Changed password successfully!'),
                  icon: 'CheckIcon'
                },
              });
            } else {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  variant: 'danger',
                  title: this.$t(response.msg),
                  icon: 'XIcon',
                },
              });
            }
          });
        }
      })
    },

  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
.fullscreen {
  background-image: linear-gradient(90deg, #b6fdb2 0%, #b6fdb2 50%, #EBFFEB 100%);
}
html[dir=ltr] .content {
    margin-left: 0px;
}
</style>
